import request from "@/utils/request";

export function countryGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Country/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function countryCreate(data) {
    return request({
        url: "/api/services/app/Country/Create",
        method: "POST",
        data
    });
}

export function countryUpdate(data) {
    return request({
        url: "/api/services/app/Country/Update",
        method: "PUT",
        data
    });
}

export function countryDelete(params) {
    return request({
        url: "/api/services/app/Country/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/country.js